import { render, staticRenderFns } from "./designMgr.vue?vue&type=template&id=f5cfbaa2&scoped=true"
import script from "./designMgr.vue?vue&type=script&lang=js"
export * from "./designMgr.vue?vue&type=script&lang=js"
import style0 from "./designMgr.vue?vue&type=style&index=0&id=f5cfbaa2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cfbaa2",
  null
  
)

export default component.exports